import React from 'react';
import { Grid, Typography, Avatar, Link, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TechniciseLogo from 'images/technicise-logo.png';
import ArogyaHospitalLogo from 'images/arogyaLogo.png';

const Footer: React.FC = () => {
  const { t } = useTranslation(['home']);

  return (
    <Box component="footer" sx={{ mt: 10, py: 3 }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <Typography sx={{ fontWeight: 'bold' }}>
            {t('copy', { ns: ['home'] })}
          </Typography>
        </Grid>

        <Grid item>
          <Link
            href="https://technicise.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Avatar
              alt="Technicise logo"
              variant="square"
              src={TechniciseLogo}
              sx={{ width: 160, height: 70 }}
            />
          </Link>
        </Grid>

        <Grid item>
          <Typography sx={{ fontWeight: 'bold' }}>&</Typography>
        </Grid>

        <Grid item>
          <Link
            href="https://srisathyasaisanjeevani.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Avatar
              alt="Arogya Hospital logo"
              variant="square"
              src={ArogyaHospitalLogo}
              sx={{ width: 220, height: 85 }}
            />
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
